<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-forum</v-icon> {{ topic.forum.title }} &raquo; {{ topic.title }}
    </v-col>
    <v-col cols="12" class="subtitle-2">
      Discussões:
    </v-col>
    <template v-if="paginate.total">
      <v-col cols="12" md="4" v-for="(discussion, index) in discussions" :key="index">
        <v-sheet outlined rounded class="fill-height">
          <v-list-item two-line :to="{ name: 'ambienteAluno.forum.topics.topic.openDiscussion', params: { forumId: forumId, topicId: topicId, discussionId: discussion.id } }">
            <v-list-item-avatar>
              <v-icon class="accent--text">mdi-account-multiple</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ discussion.title }}</v-list-item-title>
              <v-list-item-subtitle>Última atualização: {{ date(discussion) }}</v-list-item-subtitle>
              <v-list-item-subtitle>Status: {{ discussion.statusText }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ discussion.description }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click.prevent="editDiscussion(discussion.id)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-sheet>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-layout column class="pa-4">
          <v-icon size="124">mdi-emoticon-sad-outline</v-icon>
          <v-flex class="text-center">
            <span>Oops! Ainda não há discussões para este tópico.</span>
          </v-flex>
        </v-layout>
      </v-col>
    </template>
    <v-col cols="12" sm="10" md="8" class="text-center" v-if="discussions.length">
      <v-pagination v-model="paginate.pageNumber" :length="paginate.length"/>
    </v-col>
    <router-view/>
  </v-row>
</template>

<script>
import { Forum } from '@/services/resources.js'
import { mapGetters } from 'vuex'

export default {
  props: ['forumId', 'topicId'],
  beforeRouteUpdate (to, from, next) {
    if (this.forumId && from.name !== 'ambienteAluno.forum.topics.openTopic') {
      this.loadDiscussionsFromForumTopic()
    }

    next()
  },
  data () {
    return {
      paginate: {
        pageNumber: 1,
        totalVisible: 5,
        total: 0,
        length: 5
      },
      topic: {
        title: 'Título do tópico',
        description: 'Descrição',
        forum: {
          restrict: false
        }
      },
      discussions: []
    }
  },
  mounted () {
    Forum.getForumTopic(this.topicId)
      .then((response) => {
        this.topic = { ...response.body.topic }
      })
      .catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })

    // Carrega as discussões referêntes a este tópico do fórum
    this.loadDiscussionsFromForumTopic()
  },
  methods: {
    loadDiscussionsFromForumTopic () {
      Forum.discussionsFromForumTopic(this.topicId, this.paginate.pageNumber)
        .then((response) => {
          this.discussions = response.body.discussions.data
          this.paginate.pageNumber = response.body.discussions.current_page
          this.paginate.length = response.body.discussions.last_page || 5
          this.paginate.total = response.body.discussions.total
        })
        .catch((error) => {
          console.log('responseError', error)
          this.$toasted.global.error({ message: error.statusText })
        })
    },
    addDiscussion () {
      this.$router.push({ name: 'ambienteAluno.forum.topics.openTopic.newDiscussion', params: { forumId: this.forumId, topicId: this.topicId } })
    },
    editDiscussion (discussionId) {
      this.$router.push({
        name: 'ambienteAluno.forum.topics.openTopic.editDiscussion',
        params: {
          forumId: this.forumId,
          topicId: this.topicId,
          discussionId: discussionId
        }
      })
    },
    date (discussion) {
      let date = null
      if (discussion.replies.length) {
        date = new Date(discussion.replies[0].created_at)
      } else {
        const createdDate = new Date(discussion.created_at)
        const updatedDate = new Date(discussion.updated_at)

        date = createdDate.getTime() > updatedDate.getTime() ? createdDate : updatedDate
      }

      return date.toLocaleString()
    }
  },
  watch: {
    'paginate.pageNumber': function () {
      // Carrega as discussões referêntes a este tópico do fórum
      // de acordo com a paginação selecionada
      this.loadDiscussionsFromForumTopic()
    }
  },
  computed: {
    ...mapGetters({
      user: 'App/user'
    })
  }
}
</script>
